/*
 * Better Turns POS System
 * Copyright (c) 2024 Better Turns LLC
 * All rights reserved.
 *
 * Author: Gabe Mohacsi
 * Description: Quickly summarize core co-op benefits or value propositions.
 * License: Proprietary - Redistribution, modification, or use without
 * explicit permission from Better Turns LLC is prohibited.
 */

import React from 'react';

const cardData = [
  {
    icon: '📊',
    title: 'Shared Analytics',
    text: 'Leverage collective sales data for smarter decisions.',
  },
  {
    icon: '🤝',
    title: 'Member Support',
    text: 'Access personalized help from our team and co-op peers.',
  },
  {
    icon: '🛒',
    title: 'Merchandising Tools',
    text: 'Optimize your product mix like a Tier 1 retailer.',
  },
];

function InfoCards() {
  return (
    <section className="bg-soft-earth py-16 px-6 md:px-20">
      <div className="max-w-6xl mx-auto">
        <div className="grid gap-8 md:grid-cols-3 text-center">
          {cardData.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow"
            >
              <div className="text-4xl mb-4">{card.icon}</div>
              <h4 className="text-xl font-semibold mb-2">{card.title}</h4>
              <p className="text-gray-700 text-sm">{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default InfoCards;
